<template>

    <div class="step-detail">
        <p>Products</p>
        {{Products}}

        <br /><br />
        <p>Total order</p>
        {{totalOrder}}
    </div>
</template>

<script>
  import Vue from 'vue'
  import { EventBus} from '../services/eventBus'
  import apiService from '../services/request'
  export default {
    data() {
      return {
        StepOne: '',
        StepTwo: [],
        StepThree: [],
        Products: [],
        Product: {},
        totalOrder: 0
      };
    },
    name: "ExcelExport",
    methods: {
        sendExcelData () {
            apiService.sendExcelData(this.Product, 'nl-be' , this.getExcel)
        },
        getExcel(response) {
            console.log(response)
        },
    },
    mounted() {
      this.StepOne = Vue.ls.get('StepOne')
      this.StepTwo = Vue.ls.get('StepTwo')
      this.StepThree = Vue.ls.get('StepThree')

      this.Product = {StepOne: this.StepOne, StepTwo: this.StepTwo, StepThree: this.StepThree, Length:(this.StepThree.length + this.StepTwo.length +1)}
      if(Vue.ls.get('Products') !== null) {
        this.Products = Vue.ls.get('Products')
      }
      this.Products.push(this.Product)

      this.totalOrder = Vue.ls.get('totalOrder')
      this.sendExcelData()
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/ExcelExport.vue